module.exports = __webpack_public_path__ + "img/banner-1.0320f869.jpg";